// The working hours dialog's frame (4.3d.4): title, the editor, Done. Tokens only; the editor reads the screen's language itself
// (`lng` is accepted and ignored, so callers need not change).
import React from "react";
import { Box, Typography, IconButton, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Clock, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import TlButton from "../../../design-system/components/TlButton";
import WHCustomizeSection from "./WHCustomizeSection";

// eslint-disable-next-line no-unused-vars
const DaysOfWork = ({ lng, onClose }) => {
  const { t } = useTranslation("createplan");
  return (
    <>
      <DialogTitle component="div" sx={{ px: "var(--sp-6)", py: "var(--sp-4)" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "var(--sp-3)" }}>
          <Box aria-hidden="true" sx={{ width: 40, height: 40, borderRadius: "var(--r-md)", flexShrink: 0, background: "var(--c-violet-bg)", color: "var(--c-violet)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Clock size={19} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography component="h2" sx={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: "var(--t-h4)", color: "var(--ink-900)", lineHeight: 1.25 }}>
              {t("workingHoursTitle")}
            </Typography>
            <Typography sx={{ fontFamily: "var(--font-ui)", fontSize: "var(--t-caption)", color: "var(--ink-500)" }}>
              {t("configureWhenActive")}
            </Typography>
          </Box>
          {onClose && (
            <IconButton onClick={onClose} aria-label={t("done")} sx={{ width: 44, height: 44, color: "var(--ink-500)", "&:hover": { background: "var(--surface-2)" } }}>
              <X size={18} />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, borderColor: "var(--line-100)", background: "var(--surface-card)" }}>
        <WHCustomizeSection />
      </DialogContent>
      {onClose && (
        <DialogActions sx={{ px: "var(--sp-6)", py: "var(--sp-4)" }}>
          <TlButton variant="primary" onClick={onClose}>{t("done")}</TlButton>
        </DialogActions>
      )}
    </>
  );
};

export default DaysOfWork;
